<template>
  <div class="app flex-row align-items-center">
      Logout....
  </div>
</template>

<script>
import { mapActions } from 'vuex'  
import { getResponseMessages, logoutUser } from '../_helpers';
export default {
	name: 'Logout',
  	mounted() {
  		this.logout();
  	},
  	methods: {
    	...mapActions('auth', ['logout']),	
    	logout() {
			this.$store.dispatch('logout').then((res) => {
				logoutUser();
				this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
				this.$router.push('/login')
			},(error) =>{
				logoutUser();
				this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
				this.$router.push('/login')
			});
	    }
    }	  
}
</script>
